import React, { FunctionComponent } from 'react';
import { faTasks } from '@fortawesome/free-solid-svg-icons';
import { BrassIcon, BrassIconProps } from '.';

const BrassIconTasks: FunctionComponent<BrassIconProps> = (
  props: BrassIconProps,
) => <BrassIcon {...props} icon={faTasks} />;

export { BrassIconTasks };
